export enum ApplicationNotificationType {
  Epasts = 'Epasts',
  eAdrese = 'eAdrese',
  Sms = 'Sms',
}
